import {Button, Chip, Divider, Stack} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

import {TableFilter} from '@store/common/tableFilter.model';

import {Cross} from '@icons/index';

import TableFiltersDrawer from '@components/table/filters/TableFilters.drawer';
import {FilterBaseEntityEnum} from '@store/filters';

interface TableFiltersComponentProps {
  filters: any;
  handleReset: () => void;
  handleSave: (tableFilters: TableFilter[]) => void;
  handleSaveExclude?: (excludeFilters: TableFilter[]) => void;
  baseEntity?: FilterBaseEntityEnum;
}

const TableFiltersComponent = (props: TableFiltersComponentProps) => {
  const {filters, handleReset, handleSave, handleSaveExclude} = props;

  const {t} = useTranslation();

  const [openFilters, setOpenFilters] = useState(false);

  const filteredFilters = filters.tableFilters.filter((f) => !f.hide && !!f.values.length);
  const excludedFilteredFilters = filters.excludeTableFilters?.filter((f) => !f.hide && !!f.values.length) || [];

  return (
    <>
      <Stack alignItems="flex-end" spacing={1}>
        <Stack direction="row" spacing={1.5} height="40px" alignItems="center">
          <Button onClick={handleReset} variant="contained" color="primary" startIcon={<Cross/>} size="small">
            {t('global.resetFilters')}
          </Button>
          <Divider variant="fullWidth" orientation="vertical" sx={{height: '30px'}}/>
          <Button onClick={() => setOpenFilters(true)} variant="outlined" color="primary" size="small">
            {t('global.filters')}
          </Button>
        </Stack>
        <Stack direction="row-reverse" alignItems="center" spacing={1}>
          {!!filteredFilters.length && filteredFilters.map((f, index) => (
            <Chip
              key={`Active filter ${f.type} ${index}`}
              color="primary"
              disabled={f.disabled}
              onDelete={!f.disabled
                ? () => handleSave(filters.tableFilters.map((of) => of.type === f.type ? ({...of, values: []}) : of))
                : undefined
              }
              label={`${t(`global.filterFieldType.${f.type}`)} (${f.values.length})`}
              size="small"/>
          ))}
          {!!excludedFilteredFilters.length && handleSaveExclude && excludedFilteredFilters.map((f, index) => (
            <Chip
              key={`Active filter ${f.type} ${index}`}
              color="primary"
              disabled={f.disabled}
              onDelete={!f.disabled
                ? () => handleSaveExclude(filters.excludeTableFilters.map((of) => of.type === f.type ? ({
                  ...of,
                  values: []
                }) : of))
                : undefined
              }
              label={`(ex) ${t(`global.filterFieldType.${f.type}`)} (${f.values.length})`}
              size="small"/>
          ))}
        </Stack>

      </Stack>
      {openFilters && (
        <TableFiltersDrawer
          filters={filters.tableFilters}
          excludeFilters={filters.excludeTableFilters}
          baseEntity={props.baseEntity || FilterBaseEntityEnum.NONE}
          handleSave={(newFilters, excludeFilters) => {
            handleSave(newFilters);
            if (handleSaveExclude) {
              handleSaveExclude(excludeFilters || []);
            }
            setOpenFilters(false);
          }}
          handleClose={() => setOpenFilters(false)}
        />
      )}
    </>
  );
};

export default TableFiltersComponent;
